(() => {
  const root = document.getElementById('CurioChat');
  if (!root) return;
  const button = root.querySelector('button');
  const error = root.querySelector('.curio-chat-error');
  if (document.querySelector('script[src*="web-components/chat.js"]')) { root.hidden = true; return; }
  let loading;
  button.addEventListener('click', async () => {
    if (loading) return;
    button.disabled = true;
    button.textContent = button.dataset.loading;
    error.hidden = true;
    loading = (async () => {
      const response = await fetch(root.dataset.config, {credentials: 'omit'});
      if (!response.ok) throw new Error('Chat settings unavailable');
      const data = await response.json();
      let pageData = document.getElementById('shopify-chat-page-data');
      if (!pageData) {
        pageData = document.createElement('script');
        pageData.id = 'shopify-chat-page-data';
        pageData.type = 'application/json';
        pageData.textContent = JSON.stringify(data);
        document.body.append(pageData);
      }
      if (!document.getElementById('shopify-chat-app-embed-data')) {
        const embed = document.createElement('script');
        embed.type = 'application/json';
        embed.id = 'shopify-chat-app-embed-data';
        embed.textContent = JSON.stringify({settings:{invertActivatorColors:true,greetingMessage:'',showFeaturedProducts:true,featuredProducts:[],horizontalPosition:'bottom_right',icon:'chat_bubble',buttonLabel:button.dataset.label}});
        document.body.append(embed);
      }
      if (!document.querySelector('shopify-store[store-domain]')) {
        const store = document.createElement('shopify-store');
        store.setAttribute('store-domain', root.dataset.domain);
        store.setAttribute('country', root.dataset.country);
        store.setAttribute('language', root.dataset.language);
        document.body.append(store);
      }
      await Promise.all([
        import('https://cdn.shopify.com/storefront/standard-actions.js'),
        import('https://cdn.shopify.com/storefront/web-components/chat.js')
      ]);
      let chat = document.querySelector('shopify-chat');
      if (!chat) {
        chat = document.createElement('shopify-chat');
        chat.id = 'CurioChatPanel';
        document.body.append(chat);
      }
      await customElements.whenDefined('shopify-chat');
      chat.show();
      button.setAttribute('aria-expanded', 'true');
      root.hidden = true;
    })();
    try { await loading; }
    catch {
      loading = null;
      button.disabled = false;
      button.textContent = button.dataset.label;
      error.hidden = false;
    }
  });
})();
